<div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-bg-white tw-border tw-border-[#E8E8E8] tw-rounded-[10px] md:tw-px-4 lg:tw-px-8">
  <form *ngIf="formGroup" class="tw-w-full tw-h-fit tw-py-8 tw-px-4" [formGroup]="formGroup">
    <div class="tw-w-full tw-h-fit tw-flex tw-items-center tw-gap-4 tw-mb-8">
      <p class="tw-flex-1 tw-font-poppins tw-font-bold tw-text-lg tw-text-secondary">
        {{ title | translate }}
      </p>
      <div (click)="closeModal()" class="tw-min-w-8 tw-min-h-8 tw-max-w-8 tw-max-h-8 tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-full tw-cursor-pointer">
        <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/close-light-icon.svg" />
      </div>
    </div>
    <app-input [formGroup]="formGroup" formControlName="display_name" [label]="'business-display-name' | translate"></app-input>
    <app-input [formGroup]="formGroup" formControlName="name" [label]="'business-name' | translate"></app-input>
    <app-image-picker [formGroup]="formGroup" formControlName="bannerFile" imageFormControlName="bannerURL" [label]="'upload-new-banner' | translate"></app-image-picker>

    <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-3">{{ "currency" | translate }}</p>
    <div class="tw-w-full tw-h-fit tw-flex tw-flex-wrap tw-gap-4 tw-mb-5">
      <p-dropdown
        class="tw-border tw-border-grey-600 tw-rounded-[5px]"
        [options]="currencies"
        formControlName="currency"
        optionLabel="title"
        dataKey="id"
        [filter]="false"
        [showClear]="false"
        [placeholder]="'currency' | translate"
        (onChange)="setCurrency($event)"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
          <div class="tw-flex tw-items-center tw-gap-2">
            <span class="fi fi-{{ selectedOption.flag }}"></span>
            <div>{{ selectedOption.title }}</div>
          </div>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <div class="tw-flex tw-items-center tw-gap-2">
            <span class="fi fi-{{ item.flag }}"></span>
            <div>{{ item.title }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-3">{{ "payment-options" | translate }}</p>
    <div class="tw-w-fit tw-h-fit tw-flex tw-gap-4 tw-mb-5">
      <p-multiSelect
        class="tw-border tw-border-grey-600 tw-rounded-[5px]"
        [options]="paymentOptions"
        formControlName="payment_options"
        [filter]="false"
        [showClear]="false"
        [placeholder]="'payment-options' | translate"
        optionLabel="label"
        optionValue="value"
      >
        <ng-template pTemplate="selectedItems" let-value>
          <div class="tw-flex tw-flex-wrap tw-gap-2">
            <div *ngFor="let option of value; let i = index" class="tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
              {{ option.label | translate }}{{ i < value.length - 1 ? ", " : "" }}
            </div>
          </div>
        </ng-template>
        <ng-template let-option pTemplate="item">
          <div class="tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
            {{ option.label | translate }}
          </div>
        </ng-template>
      </p-multiSelect>
    </div>

    <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-3">{{ "business-categories" | translate }}</p>
    <div class="tw-w-fit tw-h-fit tw-flex tw-gap-4 tw-mb-5">
      <p-multiSelect
        class="tw-border tw-border-grey-600 tw-rounded-[5px]"
        [options]="businessCategories"
        formControlName="categories"
        [filter]="true"
        [showClear]="false"
        [selectionLimit]="3"
        [placeholder]="'business-categories' | translate"
        optionLabel="name"
      >
        <ng-template pTemplate="selectedItems" let-value>
          <div class="tw-flex tw-flex-wrap tw-gap-2">
            <div *ngFor="let category of value; let i = index" class="tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
              {{ category.emoji }} {{ category.name | translate }}{{ i < value.length - 1 ? ", " : "" }}
            </div>
          </div>
        </ng-template>
        <ng-template let-category pTemplate="item">
          <div class="tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">{{ category.emoji }} {{ category.name | translate }}</div>
        </ng-template>
      </p-multiSelect>
    </div>

    <!-- branch fields -->
    <div *ngIf="type == 'new-business'" class="tw-w-full tw-h-fit">
      <div class="tw-w-full tw-h-[1px] tw-bg-secondary/20 tw-mt-2 tw-mb-5"></div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-base tw-text-secondary tw-mb-4">{{ "new-branch" | translate }}</p>

      <app-phone-input [formGroup]="formGroup" formControlName="phone" [label]="'phone' | translate" [selectedCountryISO]="selectedCountryISO"></app-phone-input>

      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-mb-1">{{ "location" | translate }}</p>
      <div class="tw-w-full tw-h-52 tw-relative tw-overflow-hidden tw-rounded-[10px] tw-mb-6">
        <div id="map" class="tw-w-full tw-h-full !tw-z-[1]"></div>
        <button
          (click)="getUserLocation(false)"
          class="tw-w-fit tw-h-fit tw-absolute tw-bottom-8 tw-right-4 !tw-z-[99] tw-bg-tertiary hover:tw-bg-tertiary/90 active:tw-bg-tertiary/80 tw-font-poppins tw-font-semibold tw-text-xs tw-text-white tw-border tw-border-primary hover:tw-border-primary/80 tw-rounded-[5px] tw-px-2 tw-py-2 tw-shadow-lg hover:tw-shadow-xl active:tw-shadow-md tw-transition-all tw-duration-200 hover:tw-scale-105 active:tw-scale-95"
        >
          <img class="tw-w-6 tw-h-6 tw-object-contain tw-filter tw-drop-shadow-sm" src="../../../assets/user-location-marker.svg" />
        </button>
      </div>

      <div class="tw-w-full tw-h-fit tw-flex tw-flex-col md:tw-flex-row tw-gap-2">
        <app-input class="tw-flex-1 tw-max-w-full" [formGroup]="formGroup" formControlName="start_hour" [label]="'start-hour' | translate" type="time"></app-input>
        <app-input class="tw-flex-1 tw-max-w-full" [formGroup]="formGroup" formControlName="end_hour" [label]="'end-hour' | translate" type="time"></app-input>
      </div>

      <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-mb-4">
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-mb-1">{{ "off-days" | translate }}</p>
        <p-multiSelect
          class="tw-w-full tw-h-fit tw-relative tw-border tw-border-grey-600 tw-rounded-[5px]"
          [options]="weekdays"
          formControlName="off_days"
          [filter]="false"
          [showClear]="true"
          [placeholder]="'off-days' | translate"
          (onChange)="setOffDays($event)"
          (onClear)="clearOffDays()"
          optionLabel="name"
          dataKey="id"
        >
          <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
            <div class="flex align-items-center gap-2">
              <div>{{ selectedOption.name }}</div>
            </div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="flex align-items-center gap-2">
              <div>{{ item.name }}</div>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>

      <div class="full-dropdown tw-w-full tw-h-fit tw-flex tw-flex-col tw-mb-4">
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-mb-1">{{ "parent-branch" | translate }}</p>
        <p-dropdown
          class="tw-w-full tw-h-fit tw-relative tw-border tw-border-grey-600 tw-rounded-[5px]"
          [options]="parentBranches"
          [(ngModel)]="selectedParentBranch"
          [ngModelOptions]="{ standalone: true }"
          dataKey="id"
          optionLabel="name"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          [placeholder]="'parent-branch' | translate"
          (onFilter)="searchParentBranches.next($event.filter)"
          [emptyFilterMessage]="searchParentBranchesNoResults | translate"
          (onChange)="setParentBranch($event)"
        >
          <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
            <div class="flex align-items-center gap-2">
              <div>{{ selectedOption.name }}</div>
            </div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="flex align-items-center gap-2">
              <div>{{ item.name }}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <app-input [formGroup]="formGroup" formControlName="delivery_radius" [label]="'delivery-radius' | translate" type="number"></app-input>

      <div class="tw-w-full tw-h-fit tw-flex tw-flex-col md:tw-flex-row tw-gap-2">
        <app-input class="tw-flex-1 tw-max-w-full tw-min-w-0" [formGroup]="formGroup" formControlName="eta_min" [label]="'eta-min' | translate" type="number"></app-input>
        <app-input class="tw-flex-1 tw-max-w-full tw-min-w-0" [formGroup]="formGroup" formControlName="eta_max" [label]="'eta-max' | translate" type="number"></app-input>
      </div>

      <app-input [formGroup]="formGroup" formControlName="shipping_cost" [label]="'shipping-cost' | translate" type="number"></app-input>

      <app-input [formGroup]="formGroup" formControlName="min_order" [label]="'min-order' | translate" type="number"></app-input>
    </div>

    <div class="tw-w-full tw-h-2"></div>
    <app-button [disabled]="disableButton" [text]="'save' | translate" [fullWidth]="true" [onButtonClick]="buttonClicked.bind(this)"></app-button>
  </form>
</div>
